import { CREDIT_MEMO_TYPE_ID, LEAD_TYPE_ID, SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isCreditMemoToContactChickletHoverActionsArguments } from '../../types';
import { useGetCreditMemoWithAssociatedObjectsQuery } from '../../../../__generated__/chirp/com/hubspot/credit/memos/rpc/CreditMemosWithAssociatedObjectsService.hooks';
import { getEditDefaultActionsData, getPreviewDefaultActionsData, getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';
import { useMemo } from 'react';

/**
 * Determines whether to show the edit association labels action and returns the appropriate data
 */
import { jsx as _jsx } from "react/jsx-runtime";
const getEditAssociationActionData = args => {
  const {
    fromObjectTypeId
  } = args;
  switch (fromObjectTypeId) {
    case LEAD_TYPE_ID:
      return undefined;
    default:
      return getEditDefaultActionsData(args);
  }
};

/**
 * Determines whether to disable the remove association action and returns the appropriate data
 */
const getRemoveAssociationActionData = args => {
  const {
    fromObjectTypeId,
    primaryAssociationObjectId,
    objectId
  } = args;
  switch (fromObjectTypeId) {
    case CREDIT_MEMO_TYPE_ID:
      {
        var _args$creditMemoData$;
        if (!isCreditMemoToContactChickletHoverActionsArguments(args) || !args.creditMemoData) {
          return getRemoveDefaultActionsData(args, {
            disabled: true
          });
        }
        const statusProperty = (_args$creditMemoData$ = args.creditMemoData.properties) === null || _args$creditMemoData$ === void 0 ? void 0 : _args$creditMemoData$.find(prop => prop.name === 'hs_credit_memo_status');
        const creditMemoStatus = statusProperty === null || statusProperty === void 0 ? void 0 : statusProperty.value;
        const isAppliedOrPartiallyApplied = creditMemoStatus === 'applied' || creditMemoStatus === 'partially_applied';
        if (isAppliedOrPartiallyApplied) {
          return getRemoveDefaultActionsData(args, {
            disabled: true,
            disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledRemoveCreditMemoAssociationTooltip"
            })
          });
        }
        return getRemoveDefaultActionsData(args);
      }
    case LEAD_TYPE_ID:
      if (objectId === primaryAssociationObjectId) {
        return getRemoveDefaultActionsData(args, {
          disabled: true,
          disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledRemovePrimaryContactAssociationFromLeadTooltip"
          })
        });
      }
      return getRemoveDefaultActionsData(args);
    case SUBSCRIPTION_TYPE_ID:
      return getRemoveDefaultActionsData(args, {
        disabled: true,
        disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledSubscriptionToContactTooltip"
        })
      });
    default:
      return getRemoveDefaultActionsData(args);
  }
};
const useActions = baseArgs => {
  const {
    fromObjectTypeId,
    fromObjectId
  } = baseArgs;
  const {
    data: creditMemoData
  } = useGetCreditMemoWithAssociatedObjectsQuery({
    variables: {
      creditMemoId: fromObjectId
    },
    skip: fromObjectTypeId !== CREDIT_MEMO_TYPE_ID || !fromObjectId
  });
  const hydratedArgs = useMemo(() => {
    if (fromObjectTypeId === CREDIT_MEMO_TYPE_ID) {
      return Object.assign({}, baseArgs, {
        creditMemoData
      });
    }
    return baseArgs;
  }, [baseArgs, creditMemoData, fromObjectTypeId]);
  return {
    PrimaryAction: getPreviewDefaultActionsData(baseArgs),
    SecondaryActions: [getPrimaryDefaultActionsData(hydratedArgs), getEditAssociationActionData(hydratedArgs), getRemoveAssociationActionData(hydratedArgs)]
  };
};
export default useActions;